import { clsx } from 'clsx';

import { ButtonLinkStoryblok, MultilinkStoryblok } from '@monoimin/sb-types';

import { SharedLinkProps } from '../link/SharedLink';

import {
  buttonClasses,
  ButtonSize,
  ButtonVariant,
  LinkButtonProps,
} from './constants';

const sizes = {
  small: 'button-small-size',
  table: 'button-table-size',
  default: 'button-default-size body',
};
export function getButtonStyle({
  variant = 'none',
  iconRight,
  className,
  isForm,
  size = 'default',
}: {
  variant?: ButtonVariant;
  iconRight?: boolean;
  className?: string;
  isForm?: boolean;
  size?: ButtonSize;
}) {
  return clsx(
    'button-default-style select-none',
    buttonClasses[variant],
    sizes[size],
    {
      'flex-row-reverse': iconRight,
      'lg:w-fit': !isForm,
    },
    className
  );
}

export function getGhostLinkStyle({
  className = 'body',
  iconPosition,
}: {
  className?: string;
  iconPosition?: 'left' | 'right';
}) {
  return clsx(
    'button-default-style ghost-link group/button select-none',
    className,
    {
      'flex-row-reverse': iconPosition === 'left',
    }
  );
}

export const parseNewButtonProps = (
  data: ButtonLinkStoryblok
): LinkButtonProps => {
  return {
    children: data.text || data?.link?.title || null,
    href: data.link?.url || data.link?.cached_url,
    target: data.link?.['target'] || '_self',
    icon: (data.icons === 'arrow'
      ? 'arrowRight'
      : data.icons) as LinkButtonProps['icon'],
  };
};

export const parseLinkProps = (
  link?: MultilinkStoryblok
): Pick<SharedLinkProps, 'target' | 'children'> & { href: string } => {
  const href = link?.url || link?.cached_url;
  return {
    children: link?.title,
    href,
    target: link?.['target'] || '_self',
  };
};
